import React from 'react';

// local Dependencies
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { layoutConfig } from 'config/table-configs/hipaa-auth';
import { getLabel } from 'utils/getLabel';
import { widgetError as WidgetError } from 'ui/views/widgets/widgetError';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { authFlowMemberVerificationHipaaAuthorization as AuthFlowMemberVerificationHipaaAuthorization } from 'ui/views/widgets/authFlowMemberVerificationHipaaAuthorization';
 *
 * // render
 * <AuthFlowMemberVerificationHipaaAuthorization propName='propValue'/>
 */
export const authFlowMemberVerificationHipaaAuthorizationSuccess = ( props ) => {

    return (
        <div className='ui-auth-flow-member-verification-hipaa-authorization'>
            {/* title */}
            <div className='ui-auth-flow-member-verification-hipaa-authorization__title'>
                { getLabel( props.componentData.structure.title ) }
            </div>
             <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                tableResponse = { props.componentData }
                disablePagination={ true }
            />
        </div>
    );
};

// set display name
authFlowMemberVerificationHipaaAuthorizationSuccess.displayName = 'authFlowMemberVerificationHipaaAuthorizationSuccess';

// set default props
authFlowMemberVerificationHipaaAuthorizationSuccess.defaultProps = {};

// prop types
authFlowMemberVerificationHipaaAuthorizationSuccess.propTypes = {};

// ***********************************************

// preloader
const authFlowMemberVerificationHipaaAuthorizationPreloader = ( ) => {
    return (
        <div className='ui-auth-flow-member-verification-hipaa-authorization-preloader'>
            <div className='ui-auth-flow-member-verification-hipaa-authorization-preloader__title'></div>
            <TableSearchInlineWidgetPreloader />
        </div>
    );
};

// set display name
authFlowMemberVerificationHipaaAuthorizationPreloader.displayName = 'authFlowMemberVerificationHipaaAuthorizationPreloader';

// set default props
authFlowMemberVerificationHipaaAuthorizationPreloader.defaultProps = {};

// prop types
authFlowMemberVerificationHipaaAuthorizationPreloader.propTypes = {};

// ***********************************************

// error
const authFlowMemberVerificationHipaaAuthorizationError = ( props ) => {
    return (
        <div className='ui-auth-flow-member-verification-hipaa-authorization-error'>
            <WidgetError { ...props }/>
        </div>
    );
};

// set display name
authFlowMemberVerificationHipaaAuthorizationError.displayName = 'authFlowMemberVerificationHipaaAuthorizationError';

// set default props
authFlowMemberVerificationHipaaAuthorizationError.defaultProps = {};

// prop types
authFlowMemberVerificationHipaaAuthorizationError.propTypes = {};

// ***********************************************

export const authFlowMemberVerificationHipaaAuthorization = withNetworkState(
    authFlowMemberVerificationHipaaAuthorizationPreloader,
    authFlowMemberVerificationHipaaAuthorizationSuccess,
    authFlowMemberVerificationHipaaAuthorizationError,
);

